import type { FC, ReactNode } from 'react';
import React, { createContext } from 'react';

import {
	useCommentCounts,
	type UseCommentCountsData,
} from '@confluence/comments-hooks/entry-points/useCommentCounts.ts';

/**
 * @deprecated This context is deprecated and will be removed in a future version.
 * It was used to manage comment counts but is no longer needed as part of modernization.
 */
export const CommentCountsContext: React.Context<UseCommentCountsData> =
	createContext<UseCommentCountsData>({
		footerCommentsCount: 0,
		unresolvedInlineCommentsCount: 0,
	});

type CommentCountsProviderProps = {
	contentId: string;
	children: ReactNode;
};

/**
 * @deprecated This provider is deprecated and will be removed in a future version.
 * It was used to manage comment counts but is no longer needed as part of modernization.
 */
export const CommentCountsProvider: FC<CommentCountsProviderProps> = ({ contentId, children }) => {
	const commentCounts = useCommentCounts(contentId);

	return (
		<CommentCountsContext.Provider value={commentCounts}>{children}</CommentCountsContext.Provider>
	);
};
